export const Rs = "₹";
